<template>
  <div class="print-contract-container">
    <!-- (1) PageHeader -->
    <ds-page-header :title="$t('printContract.page.title')" :subtitle="$t('printContract.page.subtitle')">
      <template #extra>
        <el-button @click="_closePage">{{ $t('printContract.close') }}</el-button>
        <el-button type="primary" icon="el-icon-printer" @click="_printContractDiv">{{ $t('printContract.print') }}</el-button>
      </template>
    </ds-page-header>

    <!-- (2) 打印内容面板 -->
    <div class="ds-panel ds-panel--padded ds-print-area">
      <div v-if="printContractInfo.context" v-html="printContractInfo.context" />
      <ds-empty-state v-else :description="$t('printContract.noTemplate')" type="no-data" />
      <div id="print-btn" class="ds-print-actions">
        <el-button type="primary" @click="_printContractDiv">
          <i class="el-icon-printer" />&nbsp;{{ $t('printContract.print') }}
        </el-button>
        <el-button @click="_closePage">{{ $t('printContract.close') }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { getPrintContractTemplate } from '@/api/contract/printContractApi'
import { getCommunityId } from '@/api/community/communityApi'
import DsPageHeader from '@/components/ds/ds-page-header.vue'
import DsEmptyState from '@/components/ds/ds-empty-state.vue'

export default {
  name: 'PrintContractList',
  components: { DsPageHeader, DsEmptyState },
  data() {
    return {
      templatecontent: '',
      contractdata: '',
      contractTypeSpec: '',
      baseRepalce: [],
      attrs: [],
      printContractInfo: { contractId: '', contractTypeId: '', context: '' },
      printFlag: '0',
      communityId: ''
    }
  },
  created() {
    this.communityId = getCommunityId()
    this.printContractInfo.contractTypeId = this.$route.query.contractTypeId
    this.printContractInfo.contractId = this.$route.query.contractId
    this._loadContract()
  },
  methods: {
    _loadContract() {
      const param = {
        page: 1,
        row: 1,
        contractId: this.printContractInfo.contractId,
        contractTypeId: this.printContractInfo.contractTypeId,
        communityId: this.communityId
      }
      getPrintContractTemplate(param)
        .then(res => {
          const _data = res.data
          this.templatecontent = _data.contractTypeTemplate[0].context
          this.contractdata = _data.contract[0]
          this.attrs = _data.contract[0].attrs
          this.contractTypeSpec = _data.contractTypeSpec
          this.contractTypeSpec.forEach(e => {
            const rname = e.specName
            const rspecCd = e.specCd
            this.attrs.forEach(ea => {
              if (rspecCd === ea.specCd) {
                const reg = new RegExp('#' + rname + '#', 'g')
                this.templatecontent = this.templatecontent.replace(reg, ea.value)
              }
            })
          })
          this.baseRepalce = _data.baseRepalce
          if (this.baseRepalce) {
            this.baseRepalce.forEach(e => {
              const rname = e.name
              const rkey = e.key
              const contractarr = Object.keys(this.contractdata)
              for (const a in contractarr) {
                if (rkey === contractarr[a]) {
                  const reg = new RegExp('#' + rname + '#', 'g')
                  this.templatecontent = this.templatecontent.replace(reg, this.contractdata[contractarr[a]])
                }
              }
            })
          }
          this.printContractInfo.context = this.templatecontent
        })
        .catch(error => { console.error('请求失败:', error) })
    },
    _printContractDiv() {
      this.printFlag = '1'
      const btn = document.getElementById('print-btn')
      if (btn) btn.style.display = 'none'
      window.print()
      window.opener = null
      window.close()
    },
    _closePage() {
      window.opener = null
      window.close()
    }
  }
}
</script>

<style lang="scss" scoped>
.print-contract-container {
  padding: var(--ds-spacing-lg);
  background-color: var(--ds-gray-100);
  min-height: calc(100vh - 60px);
}
.ds-panel {
  background: #fff;
  border: 1px solid var(--ds-gray-300);
  border-radius: var(--ds-radius-md);
  box-shadow: var(--ds-shadow-sm);
  overflow: hidden;
  &--padded { padding: var(--ds-spacing-lg); }
}
.ds-print-actions {
  margin-top: var(--ds-spacing-lg);
  overflow: hidden;
  display: flex;
  justify-content: flex-end;
  gap: var(--ds-spacing-md);
}
@media print {
  .ds-print-actions { display: none; }
}
</style>
